import { makeStyles } from '@material-ui/core/styles';
const useStyles = makeStyles(({ variables, palette, breakpoints }) => ({
  courierGetStartedContent:{
    paddingLeft:variables?.spacingA,
    paddingRight:variables?.spacingA,
    '& .title-icon': {
      color: palette.jet?.supportBrand01,
      fontWeight:'bold !important'
    },
    '& .couriergetstartedcontent-title': {
      marginBottom:variables?.spacingF
    },
    '& .couriergetstarted-content-container': {
      [breakpoints.down('sm')]: {
        width:'90vw'
      },
      [breakpoints.down('xs')]: {
        width:'unset',
        height:'unset',
        marginLeft:variables?.spacingE,
        marginRight:variables?.spacingE
      },
      height:'370px',
      width:'902px',
     
      display:'flex',
      margin:'0 auto',
      boxShadow: variables?.elevation02,
      backgroundColor:palette?.jet?.supportBrand03,
      borderRadius:'32px',
      '& .couriergetstarted-content-side-section-1':{
        [breakpoints.down('xs')]:{
          width:'100%'
        },
        padding:variables?.spacingE,
        '& .get_started_button':{
          width:'270px',
          [breakpoints.down('xs')]:{
            width:'100%'
          }
        },
        '& .couriergetstarted-content-side-section-1-articles': {
          marginTop:variables?.spacingH,
          marginBottom:variables?.spacingG,
          paddingLeft:variables?.spacingNone,
          [breakpoints.down('xs')]: {
            marginTop:variables?.spacingC,
            marginBottom:variables?.spacingC,
          },
          listStyle:'none',
          '& li':{
            marginBottom:variables?.spacingE,
            "& p": {
              position:'relative',
              paddingLeft:variables?.spacingF 
            },
            "& .jetFontIcon": {
              position:'absolute',
              left:variables?.spacingNone
            }
          },
          '& .article-icon': {
            color:palette?.jet?.containerDefault,
            position:'relative',
            top:`-${variables?.spacingA}`,
            marginRight:variables?.spacingC,
            display:'block',
            float:'left'
          }
        }
      },
      '& .couriergetstarted-store-links':{
        '& img':{
          marginRight:variables?.spacingA,
          cursor:'pointer'
        }
      },
      '& .couriergetstarted-content-side-section-2':{
        '& img':{ 
          width: '240px',
          height: '347px',
          marginTop: variables?.spacingE
        },
        [breakpoints.down('xs')]:{ 
          display:'none'
        },
        display:'flex',
      }
    },
    
  },
}));

export default useStyles;
